import { MusicSearchResults } from "./music-search-results";
import { SearchDiscoveryCatalogPresets } from "./search-discovery-catalog-presets";
import { SearchDiscoveryGenreStyleChips } from "./search-discovery-genre-style-chips";
import { SearchDiscoveryIntro } from "./search-discovery-intro";
import type { useSearchMusicResults } from "./use-search-music-results";
import type { SearchFilters } from "./use-search-state";

export function SearchResultsBody({
  showDiscovery,
  filters,
  musicResults,
  preferAlbumsFirst,
  updateFilter,
  updateFilters,
}: {
  showDiscovery: boolean;
  filters: SearchFilters;
  musicResults: ReturnType<typeof useSearchMusicResults>;
  preferAlbumsFirst: boolean;
  updateFilter: (key: string, value: string | number | boolean | undefined) => void;
  updateFilters: (updates: Record<string, string | number | undefined>) => void;
}) {
  if (showDiscovery) {
    return (
      <section className="relative isolate overflow-hidden rounded-3xl border border-border bg-card px-4 py-5 shadow-sm sm:px-6 sm:py-6">
        <SearchDiscoveryIntro
          updateFilters={updateFilters}
          yearFrom={filters.yearFrom}
          yearTo={filters.yearTo}
        />
        <SearchDiscoveryCatalogPresets
          type={filters.type}
          format={filters.format}
          updateFilter={updateFilter}
        />
        <SearchDiscoveryGenreStyleChips enabled />
      </section>
    );
  }
  return (
    <MusicSearchResults
      artists={musicResults.artists}
      artistsLoading={musicResults.artistQuery.isLoading}
      artistsError={musicResults.artistQuery.error?.message}
      albums={musicResults.albums}
      albumsLoading={musicResults.albumQuery.isLoading}
      albumsError={musicResults.albumQuery.error?.message}
      labels={[]}
      companies={musicResults.companyMatches}
      listingMap={musicResults.listingMap}
      buildAlbumLink={musicResults.buildAlbumLink}
      hasMore={musicResults.hasMore}
      page={filters.page}
      preferAlbumsFirst={preferAlbumsFirst}
      query={filters.query}
      updateFilter={updateFilter}
    />
  );
}
